import { h } from "hyperapp";

export const PlaceTag = ({
  actions,
}: {
  actions: {
    setHasSelectedPlace;
    setSelectedPlace;
    setRadius;
    fetchUnvisitedPlaces;
  };
}): JSX.Element => {
  return (
    <div
      style="width:129px; height:24px;background-color:
    #17A2B8;color:white;border-radius:4px;display:flex; justify-content:center; align-items:center"
    >
      <p style="margin:0;font-size:12px;margin-right:0.5em;font-weight: 700;">
        {" "}
        Local Referência{" "}
      </p>
      <a
        onclick={event => {
          event.stopPropagation();
          actions.setHasSelectedPlace(false);
          actions.setSelectedPlace({ name: "" });
          actions.fetchUnvisitedPlaces();
          actions.setRadius({ radius: 1000 });
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M6 0.1875C2.78906 0.1875 0.1875 2.78906 0.1875 6C0.1875 9.21094 2.78906 11.8125 6 11.8125C9.21094 11.8125 11.8125 9.21094 11.8125 6C11.8125 2.78906 9.21094 0.1875 6 0.1875ZM8.85 7.52578C8.96016 7.63594 8.96016 7.81406 8.85 7.92422L7.92188 8.85C7.81172 8.96016 7.63359 8.96016 7.52344 8.85L6 7.3125L4.47422 8.85C4.36406 8.96016 4.18594 8.96016 4.07578 8.85L3.15 7.92188C3.03984 7.81172 3.03984 7.63359 3.15 7.52344L4.6875 6L3.15 4.47422C3.03984 4.36406 3.03984 4.18594 3.15 4.07578L4.07812 3.14766C4.18828 3.0375 4.36641 3.0375 4.47656 3.14766L6 4.6875L7.52578 3.15C7.63594 3.03984 7.81406 3.03984 7.92422 3.15L8.85234 4.07812C8.9625 4.18828 8.9625 4.36641 8.85234 4.47656L7.3125 6L8.85 7.52578Z"
            fill="white"
          />
        </svg>
      </a>
    </div>
  );
};
